import { render, staticRenderFns } from "./AdminPostDetail.vue?vue&type=template&id=2a7d0e92&scoped=true&"
import script from "./AdminPostDetail.vue?vue&type=script&lang=js&"
export * from "./AdminPostDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdminPostDetail.vue?vue&type=style&index=0&id=2a7d0e92&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7d0e92",
  null
  
)

export default component.exports